// The coach in the top bar: the scope glyph, the word "Coach" and, when
// something is waiting (callbacks due or overdue, drafts to approve), a
// count. It replaces the Ask Nexus door; clicking opens the coach panel on
// Today, and Ctrl/⌘+J still opens it on Ask.
import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { openAskNexus } from "../assistant/askNexusStore";
import { loadPresence, useCoach } from "../../hooks/useCoach";
import CoachGlyph from "./CoachGlyph";
import { glyphLabel } from "./coachFormat";

const POLL_MS = 120_000;

const presenceState = ({ thinking, presence }) => {
  if (thinking) return "thinking";
  return (presence?.total ?? 0) > 0 ? "attention" : "idle";
};

const CoachPresence = ({ mac = false }) => {
  const userId = useAuth()?.user?.id;
  const { presence, thinking } = useCoach({ load: false });

  useEffect(() => {
    if (!userId) return undefined;
    loadPresence();
    const timer = window.setInterval(() => {
      if (document.visibilityState === "visible") loadPresence();
    }, POLL_MS);
    const onFocus = () => loadPresence();
    window.addEventListener("focus", onFocus);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", onFocus);
    };
  }, [userId]);

  const state = presenceState({ thinking, presence });
  const count = presence?.total ?? 0;
  const label = glyphLabel(state, count);

  return (
    <button
      type="button"
      className="sg-top-ask sg-coach-presence"
      data-state={state}
      onClick={() => openAskNexus("today")}
      aria-label={label}
      aria-keyshortcuts={mac ? "Meta+J" : "Control+J"}
      data-hint={label}
      data-hint-keys={mac ? "⌘ J" : "Ctrl J"}
    >
      <CoachGlyph state={state} count={count} size="sm" />
      <span className="sg-top-ask-text">Coach</span>
    </button>
  );
};

export default CoachPresence;
